module.exports = __webpack_public_path__ + "static/media/oberflex-zebranonaturel-2560x1440.c55f3070.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-zebranonaturel-2560x1440.jpg
// module id = 1085
// module chunks = 37